import { useLanguage } from "../i18n/LanguageContext";
import { Globe, Search, Sparkles, Target, ArrowUpRight } from "lucide-react";

const iconMap = [Globe, Search, Sparkles, Target];

export default function Services() {
  const { t } = useLanguage();
  const items = t("services.items");

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-36 bg-[#F7F5F0]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-4">
            <div className="eyebrow text-ink mb-4" data-testid="services-overline">
              {t("services.overline")} · 02
            </div>
            <h2 className="heading-display text-5xl md:text-6xl lg:text-7xl" data-testid="services-title">
              {t("services.title")}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 self-end">
            <p className="text-base md:text-lg text-ink leading-relaxed">
              {t("services.sub")}
            </p>
          </div>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {items.map((item, idx) => {
            const Icon = iconMap[idx] || Globe;
            // Alternate sizes for bento feel
            const colClasses = [
              "col-span-12 md:col-span-7",
              "col-span-12 md:col-span-5",
              "col-span-12 md:col-span-5",
              "col-span-12 md:col-span-7",
            ][idx];
            const dark = idx === 1 || idx === 2;
            return (
              <article
                key={item.tag}
                data-testid={`service-card-${item.tag}`}
                className={`${colClasses} group relative p-8 md:p-12 border transition-all duration-500 hover:-translate-y-1 ${
                  dark
                    ? "bg-navy text-[#F7F5F0] border-navy"
                    : "bg-[#FFFFFF] text-navy border-[#E5E3DB] hover:border-navy"
                }`}
              >
                <div className="flex items-start justify-between mb-10 md:mb-16">
                  <div
                    className={`w-14 h-14 rounded-full grid place-items-center ${
                      dark ? "bg-green/15 text-green" : "bg-[#F7F5F0]"
                    }`}
                  >
                    <Icon size={22} strokeWidth={1.5} />
                  </div>
                  <span
                    className={`eyebrow ${dark ? "text-green" : "text-ink"}`}
                  >
                    {item.tag}
                  </span>
                </div>

                <h3 className="heading-display text-4xl md:text-5xl mb-4">{item.name}</h3>
                <p
                  className={`text-base leading-relaxed max-w-[520px] mb-8 ${
                    dark ? "text-white/75" : "text-ink"
                  }`}
                >
                  {item.desc}
                </p>

                <ul
                  className={`flex flex-wrap gap-2 text-xs tracking-wider ${
                    dark ? "text-white/70" : "text-ink"
                  }`}
                >
                  {item.points.map((p) => (
                    <li
                      key={p}
                      className={`px-3 py-1.5 rounded-full border ${
                        dark ? "border-white/15" : "border-[#E5E3DB]"
                      }`}
                    >
                      {p}
                    </li>
                  ))}
                </ul>

                <div
                  className={`mt-10 flex items-center gap-2 text-sm font-medium opacity-70 group-hover:opacity-100 transition-opacity ${
                    dark ? "text-[#F7F5F0]" : "text-navy"
                  }`}
                >
                  <a href="#contact" data-testid={`service-cta-${item.tag}`}>
                    Plan een call
                  </a>
                  <ArrowUpRight
                    size={16}
                    className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                  />
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
